import Vue from 'vue';
import {
  FETCH_EVENTS_REQUEST,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_ERROR,
  DELETE_EVENT_SUCCESS,
  FETCH_EVENT_REQUEST,
  FETCH_EVENT_SUCCESS,
  FETCH_EVENT_ERROR,
  SET_CURRENT_EVENT_ID,
  FETCH_OPERATIONS_REQUEST,
  FETCH_OPERATIONS_SUCCESS,
  FETCH_OPERATIONS_ERROR,
  USER_PAYOUTS_REQUEST,
  USER_PAYOUTS_ERROR,
  USER_PAYOUTS_SUCCESS,
  SET_USER_PAYOUTS_CURRENCY,
  USER_PAYOUT_REQUEST,
  USER_PAYOUT_SUCCESS,
  USER_PAYOUT_ERROR,
  UPDATE_USER_PAYOUTS,
  EVENT_PAYOUTS_REQUEST,
  EVENT_PAYOUTS_SUCCESS,
  EVENT_PAYOUTS_ERROR,
  ADD_EVENT_REQUEST,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_ERROR,
  ADD_TRANSACTION_REQUEST,
  ADD_TRANSACTION_SUCCESS,
  ADD_TRANSACTION_ERROR,
  UPDATE_EVENT_REQUEST,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_ERROR,
  SET_USER_TO_DELETE,
  CLEAR_USER_TO_DELETE,
  SET_PAYOUTS_ACTIVE_USER,
  SET_EVENT_CURRENCY,
  SET_EVENTS_CURRENCY,
  FETCH_EVENT_EXPENSES_REQUEST,
  FETCH_EVENT_EXPENSES_SUCCESS,
  FETCH_EVENT_EXPENSES_ERROR,
  SEND_ALL_PAYOUTS_REQUEST,
  SEND_ALL_PAYOUTS_SUCCESS,
  SEND_ALL_PAYOUTS_ERROR,
  DELETE_TRANSACTION_SUCCESS,
  DELETE_TRANSACTION_ERROR,
  MOVE_TRANSACTION_ERROR,
  ADD_PAYOUT_USER,
  DELETE_PAYOUT_USER,
  CLEAR_CURRENT_EVENT,
  SET_CURRENT_EVENT,
  SET_EVENT_ORIGINAL,
  CLEAR_EVENT_EXPENSES_UPDATE_STATUS,
  CLEAR_OPERATIONS_UPDATE_STATUS,
  CLEAR_EVENT_DATA,
  RESET_EVENT_DATA, CLEAR_EVENTS,
} from './types';
import {
  MARK_OPERATION_SEEN,
  SET_OPERATION_IN_ONE_CLICK,
} from '../operations/types';
import { resetEvent } from './eventResettingFunc';

export const getters = {
  getId: (state) => state.event.id || state.events[0].id,
  isOneClickOperation: (state) => state.isOneClickOperation,
};

export const mutations = {
  [FETCH_EVENT_REQUEST]: (state) => {
    state.eventStatus = 'loading';
  },
  [FETCH_EVENT_SUCCESS]: (state, res) => {
    state.eventStatus = 'success';
    state.currentEventId = res.id;
    Vue.set(state, 'event', res);
    const newEvents = [...state.events];
    const index = newEvents.findIndex((event) => event.id === res.id);
    if (index !== -1) {
      newEvents[index] = res;
      state.events = newEvents;
    }
  },
  [FETCH_EVENT_ERROR]: (state, e) => {
    state.eventStatus = 'error';
    state.error = e;
  },
  [SET_CURRENT_EVENT]: (state, event) => {
    state.eventStatus = 'success';
    state.event = event || {};
  },
  [CLEAR_CURRENT_EVENT]: (state) => {
    state.eventStatus = 'cleared';
    state.event = {};
    state.eventTransactions = [];
    state.eventTransactionsStatus = 'cleared';
    state.eventExpenses = {
      eventExpenses: {
        avg_expenses: 0,
        operations: [],
        total_expenses: 0,
      },
      status: 'cleared',
      error: '',
    };
    state.payouts = [];
    state.eventPayoutsStatus = 'cleared';
  },
  [SET_CURRENT_EVENT_ID]: (state, event) => {
    state.currentEventId = parseInt(event, 10);
  },
  [SET_EVENT_CURRENCY]: (state, currency) => {
    state.eventCurrency = currency;
  },
  [SET_EVENT_ORIGINAL]: (state, isOriginal) => {
    state.eventIsOriginal = isOriginal;
  },
  [FETCH_OPERATIONS_REQUEST]: (state) => {
    state.eventTransactionsStatus = 'loading';
  },
  [FETCH_OPERATIONS_SUCCESS]: (state, res) => {
    Vue.set(state, 'eventTransactions', res);
    state.eventTransactionsStatus = 'success';
  },
  [FETCH_OPERATIONS_ERROR]: (state) => {
    state.eventTransactionsStatus = 'error';
  },
  [FETCH_EVENT_EXPENSES_REQUEST]: (state, options = {}) => {
    if (options.isUpdate) {
      state.eventExpenses.updateStatus = 'loading';
    } else state.eventExpenses.status = 'loading';
  },
  [FETCH_EVENT_EXPENSES_SUCCESS]: (state, res) => {
    if (res.isUpdate
      && res.operations.length > state.eventExpenses.eventExpenses.operations.length) {
      state.eventExpenses.eventExpenses.operations
        .push(res.operations[res.operations.length - 1]);
      setTimeout(() => {
        state.eventExpenses.eventExpenses = res;
      }, 900);
    } else {
      state.eventExpenses.eventExpenses = res;
    }
    if (res.isUpdate) {
      state.eventExpenses.updateStatus = 'success';
    } else state.eventExpenses.status = 'success';
  },
  [FETCH_EVENT_EXPENSES_ERROR]: (state, e = null) => {
    if (e) state.eventExpenses.error = e;
    state.eventExpenses.status = 'error';
  },
  [CLEAR_EVENT_EXPENSES_UPDATE_STATUS]: (state) => {
    state.eventExpenses.updateStatus = '';
  },
  [EVENT_PAYOUTS_REQUEST]: (state) => {
    state.eventPayoutsStatus = 'loading';
  },
  [EVENT_PAYOUTS_SUCCESS]: (state, res) => {
    Vue.set(state, 'payouts', res);
    state.eventPayoutsStatus = 'success';
  },
  [EVENT_PAYOUTS_ERROR]: (state, e = '') => {
    if (e) { state.error = e; }
    state.eventPayoutsStatus = 'error';
  },
  [USER_PAYOUTS_REQUEST]: (state) => {
    state.userPayoutsStatus = 'loading';
  },
  [USER_PAYOUTS_SUCCESS]: (state, res) => {
    Vue.set(state, 'payouts', res);
    if (res.userId) {
      const userToSet = res.users.find((user) => user.uid === res.userId);
      Vue.set(state, 'payoutsActiveUser', userToSet);
    }
    state.userPayoutsStatus = 'success';
  },
  [USER_PAYOUTS_ERROR]: (state) => {
    state.userPayoutsStatus = 'error';
  },
  [UPDATE_USER_PAYOUTS]: (state, payoutUsers) => {
    state.payouts.users = [...payoutUsers];
  },
  [ADD_PAYOUT_USER]: (state, payoutUsers) => {
    state.payouts.users = [...payoutUsers];
  },
  [DELETE_PAYOUT_USER]: (state, { user }) => {
    state.payouts.users = state.payouts.users
      .filter((payoutUser) => payoutUser.phone !== user.phone);
  },
  [SET_USER_PAYOUTS_CURRENCY]: (state, currency) => {
    state.userPayoutsCurrency = currency;
  },
  [USER_PAYOUT_REQUEST]: (state) => {
    state.userPayoutsStatus = 'loading';
  },
  [USER_PAYOUT_SUCCESS]: (state, res) => {
    state.payoutsActiveUser = res;
    state.userPayoutsStatus = 'success';
  },
  [USER_PAYOUT_ERROR]: (state) => {
    state.userPayoutsStatus = 'error';
  },
  [SET_PAYOUTS_ACTIVE_USER]: (state, user) => {
    state.payoutsActiveUser = user;
  },
  [SEND_ALL_PAYOUTS_REQUEST]: (state) => {
    state.userPayoutsStatus = 'loading';
  },
  [SEND_ALL_PAYOUTS_SUCCESS]: (state, res) => {
    state.userPayoutsStatus = 'success';
    state.payoutsActiveUser = res;
    const index = state.payouts.users
      .findIndex((user) => user.uid === res.uid);
    state.payouts.users.splice(index, 1, res);
  },
  [SEND_ALL_PAYOUTS_ERROR]: (state) => {
    state.userPayoutsStatus = 'error';
  },
  [FETCH_EVENTS_REQUEST]: (state) => {
    state.eventsStatus = 'loading';
  },
  [FETCH_EVENTS_SUCCESS]: (state, resp) => {
    state.events = resp.objects;
    setTimeout(() => { state.eventsStatus = 'success'; }, 500);
  },
  [FETCH_EVENTS_ERROR]: (state, e = '') => {
    state.eventsStatus = 'error';
    state.error = e;
  },
  [SET_EVENTS_CURRENCY]: (state, currency) => {
    state.eventsCurrency = currency;
  },
  [DELETE_EVENT_SUCCESS]: (state, id) => {
    state.events = state.events.filter((item) => item.id !== id);
  },
  [DELETE_TRANSACTION_SUCCESS]: (state, id) => {
    state.eventTransactionsStatus = 'success';
    state.updateTransactionsStatus = 'success';
    state.eventTransactions = state.eventTransactions.filter((item) => item.id !== id);
  },
  [DELETE_TRANSACTION_ERROR]: (state, e) => {
    state.eventTransactionsStatus = 'error';
    state.updateTransactionsStatus = 'error';
    state.eventError = `failed to delete transaction: ${e.message}`;
  },
  [MOVE_TRANSACTION_ERROR]: (state, e) => {
    state.moveTransactionError = e.message;
  },
  [ADD_EVENT_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADD_EVENT_SUCCESS]: (state, newEvent) => {
    if (Array.isArray(state.events)) {
      state.events = [...state.events, newEvent];
    } else {
      state.events = [newEvent];
    }
    state.status = 'success';
  },
  [ADD_EVENT_ERROR]: (state, e) => {
    if (e) { state.error = e; }
    state.status = 'error';
  },
  [UPDATE_EVENT_REQUEST]: (state) => {
    state.eventStatus = 'loading';
  },
  [UPDATE_EVENT_SUCCESS]: (state, newEvent) => {
    state.event = newEvent || {};
    const index = state.events.findIndex((event) => event.id === newEvent.id);
    const newEvents = [...state.events];
    newEvents[index] = newEvent;
    state.events = newEvents;
    state.eventStatus = 'success';
  },
  [UPDATE_EVENT_ERROR]: (state, e) => {
    if (e) { state.error = e; }
    state.eventStatus = 'error';
  },
  [SET_USER_TO_DELETE]: (state, user) => {
    state.userToDelete = user;
  },
  [CLEAR_USER_TO_DELETE]: (state) => {
    state.userToDelete = '';
  },
  [ADD_TRANSACTION_REQUEST]: (state) => {
    state.updateTransactionsStatus = 'loading';
  },
  [ADD_TRANSACTION_SUCCESS]: (state, newTransaction) => {
    state.eventTransactions.push(newTransaction);
    state.updateTransactionsStatus = 'success';
  },
  [ADD_TRANSACTION_ERROR]: (state, e) => {
    if (e) { state.error = e; }
    state.updateTransactionsStatus = 'error';
  },
  [CLEAR_OPERATIONS_UPDATE_STATUS]: (state) => {
    state.updateTransactionsStatus = '';
  },
  [CLEAR_EVENTS]: (state) => {
    state.events = [];
    state.eventsStatus = '';
    state.error = '';
  },
  [CLEAR_EVENT_DATA]: (state) => {
    state.event = {};
    state.eventStatus = 'loading';
    state.eventTransactions = [];
    state.eventTransactionsStatus = 'loading';
    state.eventExpenses = {
      eventExpenses: {
        avg_expenses: 0,
        operations: [],
        total_expenses: 0,
      },
      status: 'loading',
      updateStatus: '',
      error: '',
    };
    state.payouts = [];
    state.eventPayoutsStatus = 'loading';
    state.currentEventId = 0;
  },
  [RESET_EVENT_DATA]: (state) => {
    resetEvent(state);
  },
  [MARK_OPERATION_SEEN]: (state, markAll) => {
    if (markAll) {
      state.event.unread_cnt = 0;
    } else {
      state.event.unread_cnt = state.event.unread_cnt > 0 ? state.event.unread_cnt - 1 : 0;
    }
  },
  [SET_OPERATION_IN_ONE_CLICK]: (state, payload) => {
    state.isOneClickOperation = payload;
  },
  // [AUTH_LOGOUT]: (state) => {
  //   state.status = '';
  //   state.events = [];
  // },
};

export const state = {
  status: '',
  error: '',
  events: [],
  eventsStatus: 'loading',
  eventsCurrency: '',
  eventStatus: 'loading',
  eventError: '',
  event: {},
  eventExpenses: {
    eventExpenses: {
      avg_expenses: 0,
      operations: [],
      total_expenses: 0,
    },
    status: 'loading',
    updateStatus: '',
    error: '',
  },
  moveTransactionError: '',
  currentEventId: 0,
  eventCurrency: '',
  eventIsOriginal: false,
  userToDelete: '',
  eventTransactions: [],
  eventTransactionsStatus: 'loading',
  updateTransactionsStatus: '',
  payouts: [],
  eventPayoutsStatus: 'loading',
  userPayoutsCurrency: '',
  payoutsActiveUser: {},
  userPayoutsStatus: '',
  isOneClickOperation: false,
};
